<template>
    <div class="echarts-wrapper" style="display:inline-block">
        <div class="echarts"></div>
    </div>
</template>

<script>

    export default {
        name: 'swb-echarts',
        desc: 'ECharts图表',
        props: {
            media: {//canvas , svg
                type: String,
                default: null
            },
            width: {//宽度
                default: 400
            },
            height: {//高度
                default: 300
            },
            option: {//setOption
                default: null
            },
            notMerge: {//setOption
                type: Boolean,
                default: false
            },
            lazyUpdate: {//setOption
                type: Boolean,
                default: false
            },
            group: {
                type: String,
                default: null
            },
            loadingText: {
                type: String,
                default: '加载中...'
            }
        },
        data: function () {
            return {};
        },
        watch: {
            width(newVal, oldVal) {
                this.resize(this.width, this.height);
            },
            height(newVal, oldVal) {
                this.resize(this.width, this.height);
            },
            option(newVal, oldVal) {
                this.setOption(this.option, this.notMerge, this.lazyUpdate);
            },
            group(newVal, oldVal) {
                this.setGroup(this.group);
            }
        },
        mounted() {
            if(typeof echarts == 'undefined') {
                console.error('缺少 echarts.js');
                return;
            }
            //
            let initOpts = {
                width: this.width,
                height: this.height
            };
            if(this.media) {
                initOpts.renderer = this.media;
            }
            let theDom = this.$el.childNodes[0];
            this.instance = echarts.init(theDom, null, initOpts);
            //
            this.setOption(this.option, this.notMerge, this.lazyUpdate);
            this.setGroup(this.group);
            //
            this.$emit('ready', this.instance);
        },
        beforeDestroy() {
            if(this.instance != null) {
                try {
                    this.instance.dispose();
                }
                catch(ex) {
                    //
                }
                this.instance = null;
            }
            //
            this.option = null;
        },
        methods: {
            setOption(option = null, notMerge = false, lazyUpdate = false) {
                if(this.instance == null) {
                    return;
                }
                if(this.loadingText) {
                    this.instance.showLoading('default', {
                        text: this.loadingText
                    });
                }
                //
                this.instance.setOption(option || {}, notMerge, lazyUpdate);
                //
                if(this.loadingText) {
                    this.instance.hideLoading();
                }
            },
            //https://www.echartsjs.com/zh/api.html#events
            on(eventName, eventTarget, handler) {
                if(this.instance == null) {
                    return;
                }
                if(typeof eventTarget == 'function') {
                    handler = eventTarget;
                    this.instance.on(eventName, handler);
                }
                else {
                    this.instance.on(eventName, eventTarget, handler);
                }
            },
            off(eventName, handler) {
                if(this.instance == null) {
                    return;
                }
                this.instance.off(eventName, handler);
            },
            resize(width = 'auto', height = 'auto') {
                if(this.instance == null) {
                    return;
                }
                let opts = {
                    width: width,
                    height: height
                };
                this.instance.resize(opts);
            },
            dispatchAction(action) {
                if(this.instance == null) {
                    return;
                }
                this.instance.dispatchAction(action);
            },
            getDataURL(opts) {
                if(this.instance == null) {
                    return;
                }
                opts = opts || 'png';
                if(typeof opts == 'string') {
                    opts = {
                        type: opts
                    };
                }
                return this.instance.getDataURL(opts);
            },
            setGroup(group) {
                if(this.instance == null) {
                    return;
                }
                this.instance.group = group || null;
            },
            getSize() {
                if(this.instance == null) {
                    return null;
                }
                return {
                    width: this.instance.getWidth(),
                    height: this.instance.getHeight()
                };
            },
            clear() {
                if(this.instance == null) {
                    return;
                }
                this.instance.clear();
            }
        }
    }

</script>




// WEBPACK FOOTER //
// src/compo/ctrl/ECharts.vue